
import PropTypes from "prop-types";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";
import { useMaterialUIController } from "context";
// import { Tooltip } from "@material-ui/core";

function SidenavCollapse({ iconUsed, icon, name, active, newSet, sideIcon, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;

  return (
    <ListItem component="li">

      {/* <Tooltip placement="top" title={<span style={{ fontSize: '13px' }}>{name}</span>} > */}
      <MDBox
        style={newSet && { paddingLeft: "25px" }}
        {...rest}

        sx={(theme) =>
          collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            miniSidenav,
            darkMode,
            sidenavColor,
          })
        }
      >
        <ListItemIcon
          sx={(theme) =>
            collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
          }
        >
          {/* <Tooltip title={name}  > */}
          {typeof icon === "string" ? (
            <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
          ) : (
            <span className={darkMode && transparentSidenav && "create"}>{icon}</span>
          )}
        </ListItemIcon>

        <ListItemText
          // primary={name}
          primary={
            <div style={{ whiteSpace: 'pre-wrap', lineHeight: "20px" }}>
              {!miniSidenav && name}
            </div>
          }
          sx={(theme) =>
            collapseText(theme, {
              miniSidenav,
              transparentSidenav,
              whiteSidenav,
              active,
            })
          }
        />
        {iconUsed === true && <>
          {typeof sideIcon === "string" ? (
            <Icon sx={(theme) => collapseIcon(theme, { active })}>{sideIcon}</Icon>
          ) : (
            <span style={{ display: "flex", alignItems: "center" }} className={darkMode && transparentSidenav && "create"}>
              {sideIcon}
              </span>
          )}</>
        }
      </MDBox>
      {/* </Tooltip> */}
    </ListItem>
  );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
  active: false,
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavCollapse;
